import body from './body.js'
import MODAL_FOOTER from './footer.js'

const MODAL_BODY = body

export { MODAL_FOOTER, MODAL_BODY }
